import { cn } from '@/lib/utils';

// Explicit class strings (not interpolated) so Tailwind's content scanner keeps them.
// Both layouts start at 2 columns on mobile so stat tiles look consistent
// across pages; they only widen further up. (4-up waits until lg so the
// dashboard's 4 tiles don't crowd beside its fixed sidebar on medium screens.)
const COLS = {
  4: 'grid-cols-2 lg:grid-cols-4',
  5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5',
};

/**
 * Responsive grid for StatCards. Defaults to a 4-up layout that collapses to
 * 2-up (sm) and 1-up (mobile) — which keeps stat labels from overflowing on
 * medium screens (e.g. beside the dashboard's fixed-width sidebar). Pass
 * `cols={5}` for pages with five tiles.
 */
const StatsGrid = ({ cols = 4, className, children }) => (
  <div className={cn('grid gap-4 mb-8', COLS[cols] || COLS[4], className)}>{children}</div>
);

export default StatsGrid;
